import { jsx as C } from "react/jsx-runtime";
import { useMemo as u, useCallback as m } from "react";
import { Cascader as v } from "antd";
import { u as b } from "../../styled-components.browser.esm-BFmoFexH.js";
import { l as S } from "../../lodash-DeBCDn4U.js";
const k = ({
  value: o,
  defaultView: t,
  placeholder: a,
  canRemove: n,
  onChange: s,
  viewsWithMetrics: d,
  unavailableViews: i,
  getPopupContainer: p
}) => {
  const c = u(
    () => d.map((e) => ({
      value: e.code,
      label: e.alias,
      children: e.metrics.map(({ alias: r, code: l }) => ({
        value: l,
        label: r
      }))
    })).concat(i.map((e) => ({
      value: e.code,
      label: e.alias,
      disabled: !0,
      children: e.metrics.map(({ alias: r, code: l }) => ({
        value: l,
        label: r
      }))
    }))),
    [d, i]
  ), f = m(
    (e) => e.length === 2 ? e.join(" / ") : void 0,
    []
  ), h = m(
    (e) => {
      const r = e && e[0] ? c.find((l) => l.value === e[0]) : void 0;
      e && r && e.length > 1 && S.isString(e[1]) ? s({
        viewCode: r == null ? void 0 : r.value,
        viewAlias: r == null ? void 0 : r.label,
        metricCode: e[1],
        additionalFilters: [],
        titlePartOverrides: {}
      }) : e === void 0 && s(null);
    },
    [s, c]
  );
  return /* @__PURE__ */ C(g, { options: c, placeholder: a, allowClear: n, showSearch: x, value: L(o, t) ?? [], displayRender: f, onChange: h, getPopupContainer: p, multiple: !1 });
}, x = {
  filter: (o, t) => t.some((a) => a.label.toLocaleLowerCase().indexOf(o.toLocaleLowerCase()) > -1),
  matchInputWidth: !1
}, L = (o, t) => o ? [o.viewCode, o.metricCode] : o && t ? [t] : void 0, g = b(v)`
  width: 100%;
`;
export {
  k as default
};
//# sourceMappingURL=MetricSelectorCascader.js.map
